import { WebApiClient } from "@verity/api-client";

/**
 * Gets the currently shared Api Client for this configuration.
 */
const apiClientPlatformConfig = {
	verityOrigin: window.location.origin,
	lockdown: {
		origin: import.meta.env.VITE_LOCKDOWN_S3_BUCKET_URL,
		channel: import.meta.env.VITE_LOCKDOWN_CHANNEL,
		cdnBaseUrl: import.meta.env.VITE_LOCKDOWN_CDN_BASE_URL,
	},
};

const apiClient = WebApiClient.getInstance(apiClientPlatformConfig);
export default apiClient;

export async function sendExtensionAuthCode() {
	const payload = await apiClient.authentication.getAccessControlAuthCode();
	return new Promise((res) => {
		chrome.runtime.sendMessage(
			import.meta.env.VITE_EXTENSION_ID,
			{
				request: "authCode",
				payload: payload,
			},
			(_response) => {
				if (chrome?.runtime?.lastError) {
					console.error(`Extension 'authCode' external message error: ${chrome.runtime.lastError.message}`);
					res(false);
				}
				res(true);
			},
		);
	});
}
